import {NodeCreator} from './NodeCreator';



export const CreateQuestion = ({ open, onClose, ws, onNodeCreated, taskId, courseDispatchId, groupId, wallType }) => {
  // 如果沒有指定 wallType，默認為 "question"（問題牆）
  // 如果從想法牆調用，應該傳入 wallType="idea"
  const finalWallType = wallType || "question";

  const nodePlan = {
    title: "新增提問",
    label: "問題標題",
    tags: "question",
    helperMsg: "請為你提問下一個標題，讓其他同學能更快速的了解你想了解什麼！",
    scaffoldBody: [
      "【我很好奇】",
      "【我想了解】",
      "【想請問】",
    ],
    scaffoldWords: ["我很好奇","我想了解","想請問"],
    wall_type: finalWallType, // 根據調用來源決定牆面類型
    task_id: taskId || null, // 傳遞關聯的任務ID
    course_dispatch_id: courseDispatchId || null,
    group_id: groupId || null
  };

 return <NodeCreator open={open} onClose={onClose} ws={ws} nodePlan={nodePlan} onNodeCreated={onNodeCreated} />;
}
   
